/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M8 5L8.45298 3.64105C8.64969 3.05094 8.74804 2.75588 8.93047 2.53774C9.09156 2.3451 9.29844 2.19599 9.53213 2.10408C9.79677 2 10.1078 2 10.7298 2H13.2702C13.8922 2 14.2032 2 14.4679 2.10408C14.7016 2.19599 14.9084 2.3451 15.0695 2.53774C15.252 2.75588 15.3503 3.05094 15.547 3.64105L16 5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M4 5L4.64564 15.9758C4.77037 18.0962 4.83273 19.1564 5.28528 19.961C5.68366 20.6692 6.28832 21.2394 7.01876 21.5955C7.84851 22 8.91054 22 11.0346 22H12.9654C15.0895 22 16.1515 22 16.9812 21.5955C17.7117 21.2394 18.3163 20.6692 18.7147 19.961C19.1673 19.1564 19.2296 18.0962 19.3544 15.9758L20 5M4 5H2M4 5H20M20 5H22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M4.64564 15.9758L4 5H20L19.3544 15.9758C19.2296 18.0962 19.1673 19.1564 18.7147 19.961C18.3163 20.6692 17.7117 21.2394 16.9812 21.5955C16.1515 22 15.0895 22 12.9654 22H11.0346C8.91054 22 7.84851 22 7.01876 21.5955C6.28832 21.2394 5.68366 20.6692 5.28528 19.961C4.83273 19.1564 4.77037 18.0962 4.64564 15.9758Z"
				fill="currentColor"
			/>
			<path
				d="M4 5L4.64564 15.9758C4.77037 18.0962 4.83273 19.1564 5.28528 19.961C5.68366 20.6692 6.28832 21.2394 7.01876 21.5955C7.84851 22 8.91054 22 11.0346 22H12.9654C15.0895 22 16.1515 22 16.9812 21.5955C17.7117 21.2394 18.3163 20.6692 18.7147 19.961C19.1673 19.1564 19.2296 18.0962 19.3544 15.9758L20 5M4 5H2M4 5H20M20 5H22M16 5L15.547 3.64105C15.3503 3.05094 15.252 2.75588 15.0695 2.53774C14.9084 2.3451 14.7016 2.19599 14.4679 2.10408C14.2032 2 13.8922 2 13.2702 2H10.7298C10.1078 2 9.79677 2 9.53213 2.10408C9.29844 2.19599 9.09156 2.3451 8.93047 2.53774C8.74804 2.75588 8.64969 3.05094 8.45298 3.64105L8 5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.7298 1.25003L10.621 1.24992C10.1084 1.24916 9.65851 1.24848 9.25763 1.40615C8.90709 1.54402 8.59677 1.76768 8.35513 2.05663C8.07878 2.38709 7.93715 2.81412 7.77577 3.30067L7.74147 3.40391L7.45943 4.25003H4H2C1.58579 4.25003 1.25 4.58582 1.25 5.00003C1.25 5.41424 1.58579 5.75003 2 5.75003H3.29282L3.89693 16.0199L3.89881 16.0518C3.95958 17.085 4.0078 17.9049 4.09968 18.5652C4.19376 19.2414 4.34057 19.8113 4.63159 20.3287C5.10467 21.1698 5.8227 21.8468 6.6901 22.2697C7.22368 22.5298 7.80125 22.6429 8.48175 22.6971C9.14635 22.75 9.9677 22.75 11.0027 22.75H11.0346H12.9654H12.9973C14.0323 22.75 14.8537 22.75 15.5182 22.6971C16.1987 22.6429 16.7763 22.5298 17.3099 22.2697C18.1773 21.8468 18.8953 21.1698 19.3684 20.3287C19.6594 19.8113 19.8062 19.2414 19.9003 18.5652C19.9922 17.9049 20.0404 17.0851 20.1012 16.052L20.1012 16.0519L20.1031 16.0199L20.7072 5.75003H22C22.4142 5.75003 22.75 5.41424 22.75 5.00003C22.75 4.58582 22.4142 4.25003 22 4.25003H20H16.5406L16.2585 3.40391L16.2242 3.30066C16.0629 2.81412 15.9212 2.38709 15.6449 2.05663C15.4032 1.76768 15.0929 1.54402 14.7424 1.40615C14.3415 1.24848 13.8916 1.24916 13.379 1.24992L13.2702 1.25003H10.7298ZM9.04057 4.25003H14.9594L14.8355 3.87825C14.6186 3.22743 14.5633 3.10155 14.4942 3.0189C14.4137 2.92258 14.3102 2.84803 14.1934 2.80207C14.0931 2.76263 13.9562 2.75003 13.2702 2.75003H10.7298C10.0438 2.75003 9.9069 2.76263 9.80663 2.80207C9.68979 2.84803 9.58635 2.92258 9.5058 3.0189C9.43668 3.10155 9.38144 3.22743 9.16449 3.87825L9.04057 4.25003Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M4 5L4.64564 15.9758C4.77037 18.0962 4.83273 19.1564 5.28528 19.961C5.68366 20.6692 6.28832 21.2394 7.01876 21.5955C7.84851 22 8.91054 22 11.0346 22H12.9654C15.0895 22 16.1515 22 16.9812 21.5955C17.7117 21.2394 18.3163 20.6692 18.7147 19.961C19.1673 19.1564 19.2296 18.0962 19.3544 15.9758L19.7647 9M4 5H2M4 5H22M16 5L15.547 3.64105C15.3503 3.05094 15.252 2.75588 15.0695 2.53774C14.9084 2.3451 14.7016 2.19599 14.4679 2.10408C14.2032 2 13.8922 2 13.2702 2H10.7298C10.1078 2 9.79677 2 9.53213 2.10408C9.29844 2.19599 9.09156 2.3451 8.93047 2.53774C8.74804 2.75588 8.64969 3.05094 8.45298 3.64105L8 5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M4 5L4.64564 15.9758C4.77037 18.0962 4.83273 19.1564 5.28528 19.961C5.68366 20.6692 6.28832 21.2394 7.01876 21.5955C7.84851 22 8.91054 22 11.0346 22H12.9654C15.0895 22 16.1515 22 16.9812 21.5955C17.7117 21.2394 18.3163 20.6692 18.7147 19.961C19.1673 19.1564 19.2296 18.0962 19.3544 15.9758L20 5M4 5H2M4 5H20M20 5H22M16 5L15.547 3.64105C15.3503 3.05094 15.252 2.75588 15.0695 2.53774C14.9084 2.3451 14.7016 2.19599 14.4679 2.10408C14.2032 2 13.8922 2 13.2702 2H10.7298C10.1078 2 9.79677 2 9.53213 2.10408C9.29844 2.19599 9.09156 2.3451 8.93047 2.53774C8.74804 2.75588 8.64969 3.05094 8.45298 3.64105L8 5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M3.20459 4.25L3.84987 15.2198C4.00578 17.8703 4.08374 19.1955 4.64942 20.2012C5.1474 21.0866 5.90322 21.7992 6.81627 22.2444C7.85347 22.75 9.181 22.75 11.8361 22.75H12.1639C14.819 22.75 16.1465 22.75 17.1837 22.2444C18.0968 21.7992 18.8526 21.0866 19.3506 20.2012C19.9163 19.1955 19.9942 17.8703 20.1501 15.2198L20.7954 4.25H3.20459Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.621 1.24992C10.657 1.24998 10.6932 1.25003 10.7298 1.25003H13.2702C13.3068 1.25003 13.343 1.24998 13.379 1.24992C13.8916 1.24916 14.3415 1.24848 14.7424 1.40615C15.0929 1.54402 15.4032 1.76768 15.6449 2.05663C15.9212 2.38709 16.0629 2.81412 16.2242 3.30066C16.2355 3.33479 16.247 3.36921 16.2585 3.40391L16.5406 4.25003H20H22C22.4142 4.25003 22.75 4.58582 22.75 5.00003C22.75 5.41424 22.4142 5.75003 22 5.75003H20H16.0173C16.0057 5.7503 15.9941 5.7503 15.9825 5.75003H8.01751C8.00594 5.7503 7.99433 5.7503 7.9827 5.75003H4H2C1.58579 5.75003 1.25 5.41424 1.25 5.00003C1.25 4.58582 1.58579 4.25003 2 4.25003H4H7.45943L7.74147 3.40391C7.75304 3.36921 7.76445 3.33479 7.77577 3.30067C7.93715 2.81412 8.07878 2.38709 8.35513 2.05663C8.59677 1.76768 8.90709 1.54402 9.25763 1.40615C9.65851 1.24848 10.1084 1.24916 10.621 1.24992ZM9.04057 4.25003H14.9594L14.8355 3.87825C14.6186 3.22743 14.5633 3.10155 14.4942 3.0189C14.4137 2.92258 14.3102 2.84803 14.1934 2.80207C14.0931 2.76263 13.9562 2.75003 13.2702 2.75003H10.7298C10.0438 2.75003 9.9069 2.76263 9.80663 2.80207C9.68979 2.84803 9.58635 2.92258 9.5058 3.0189C9.43668 3.10155 9.38144 3.22743 9.16449 3.87825L9.04057 4.25003Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
